import React from "react";
import { Link } from "react-router-dom";

const AIMusicFrameworkSection: React.FC = () => {
  const frameworkHighlights = [
    "Deep dive into how assessment and guidance",
    "Manage assessment for the main components", 
    "Get real-time feedback on DMCA deep dive",
    "Valuable feedback for AI detection"
  ];

  return (
    <div className="relative py-24 bg-gradient-to-br from-white via-blue-50/30 to-gray-50 overflow-hidden">
      {/* 3D Background Elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-tagblue/10 rounded-2xl rotate-45 animate-float blur-sm" />
      <div className="absolute bottom-20 right-10 w-24 h-24 bg-tagblue-light/10 rounded-full animate-float blur-sm" style={{ animationDelay: '2s' }} />
      
      <div className="relative container mx-auto px-6 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-gray-900 via-tagblue to-gray-900 mb-6">
              AI Music Framework
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              A comprehensive study of the framework would provide for businesses setting up predictive AI systems & businesses.
            </p>
            
            <div className="mb-10">
              <h3 className="text-xl md:text-2xl font-semibold text-gray-900 mb-6">Framework Highlights</h3>
              <div className="space-y-4">
                {frameworkHighlights.map((highlight, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-tagblue rounded-full flex items-center justify-center mt-0.5">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 6L9 17l-5-5" />
                      </svg>
                    </div>
                    <span className="text-gray-700 text-base md:text-lg">{highlight}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <Link 
              to="/contact" 
              className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-tagblue to-tagblue-light text-white py-4 px-8 rounded-2xl hover:from-tagblue-dark hover:to-tagblue transition-all duration-300 font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              Get Early Access
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-4-4m4 4l4-4m6-6v10a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h16a2 2 0 012 2z" />
              </svg>
            </Link>
          </div>
          
          {/* Right Visual */}
          <div className="flex justify-end lg:justify-center xl:justify-end">
            <div className="relative">
              {/* Glow effect */}
              <div className="absolute -inset-4 bg-gradient-to-r from-tagblue to-tagblue-light rounded-3xl blur-3xl opacity-20 animate-pulse-glow" />
              
              {/* Main visual container */}
              <div className="relative bg-white/90 backdrop-blur-md border border-white/50 rounded-3xl p-12 shadow-2xl">
                {/* 3D floating elements */}
                <div className="absolute -top-2 -left-2 w-6 h-6 bg-tagblue/30 rounded-lg rotate-45 animate-float" />
                <div className="absolute -bottom-2 -right-2 w-4 h-4 bg-tagblue-light/30 rounded-full animate-float" style={{ animationDelay: '1s' }} />
                
                <div className="text-center">
                  <div className="text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-tagblue to-tagblue-light mb-4">
                    AI Music<br />Framework
                  </div>
                  <div className="w-16 h-1 bg-gradient-to-r from-tagblue to-tagblue-light rounded-full mx-auto mb-4" />
                  <p className="text-gray-600 text-sm">Comprehensive Guide</p>
                  <p className="text-gray-600 text-sm">for the Music Industry</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIMusicFrameworkSection;